common.View.create('admin.organizations.CreateEdit', {

    onDOMLoad() {
        this.initNotifications();
    },

	initNotifications() {

        console.log( this.element.find('.can-disable input[type="checkbox"].enable-disable-box') );
        this.element.find('.can-disable input[type="checkbox"].enable-disable-box').change(function(){

                $(this).parents('.card')
                    .toggleClass('opacity-50 cursor-disabled');

        });

    },

});
